import Icon from '../components/Icon.vue'

Icon.register({
  sms: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32c141.4 0 256 93.1 256 208s-114.6 208-256 208c-38.4 0-74.7-7.1-107.4-19.4-24.6 19.6-74.3 51.4-140.6 51.4-3.2 0-6-1.8-7.3-4.8s-0.7-6.4 1.5-8.7c0.5-0.5 42.3-45.4 54.8-95.8-35.6-35.7-57-81.1-57-130.7 0-114.9 114.6-208 256-208zM128.2 304c23.4 0 42.5-17.3 42.4-38.6 0-10.6-4.8-20.9-13.3-28.1l-21.9-18.8c-1.3-1.1-2.1-2.5-2.1-3.8 0-3.1 4.4-6.6 10.4-6.6h12.3c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.2c-23.4 0-42.4 17.3-42.4 38.6 0 10.6 4.8 20.9 13.3 28.1l21.9 18.8c1.3 1.1 2.1 2.5 2.1 3.8 0 3.1-4.4 6.6-10.4 6.6h-12.3c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.2zM320 296v-104c0-8.8-7.2-16-16-16h-16c-6 0-11.6 3.4-14.3 8.8l-17.7 35.4-17.7-35.4c-2.7-5.4-8.2-8.8-14.3-8.8h-16c-8.8 0-16 7.2-16 16v104c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-68.2l24.9 55.8c2.9 5.9 11.4 5.9 14.3 0l24.8-55.8v68.2c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zM368.3 304c23.4 0 42.4-17.3 42.3-38.6 0-10.6-4.8-20.9-13.3-28.1l-21.9-18.8c-1.3-1.1-2.1-2.5-2.1-3.8 0-3.1 4.4-6.6 10.4-6.6h12.3c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.2c-23.4 0-42.4 17.3-42.4 38.6 0 10.6 4.8 20.9 13.3 28.1l21.9 18.8c1.3 1.1 2.1 2.5 2.1 3.8 0 3.1-4.4 6.6-10.4 6.6h-12.3c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sms.js
// module id = 1909
// module chunks = 0